/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Layout,
  Card,
  Tabs,
  Table,
  Tag,
  Descriptions,
  Button,
  Spin,
} from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { postAPI } from "../../../utils/common";
import { ERROR_MSG_TYPE } from "../../../constants/messages";
import {
  LAUNDRY_ITEM_BY_ID,
  STOCK_LEDGER,
} from "../../../constants/api";

const { Content } = Layout;

function ItemDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);
  const [ledger, setLedger] = useState([]);

  useEffect(() => {
    fetchItem();
    fetchLedger();
  }, []);

  const fetchItem = () => {
    setLoading(true);

    postAPI(
      LAUNDRY_ITEM_BY_ID,
      { id },
      (res) => {
        if (res.status) {
          setItem(res.data);
        }
        setLoading(false);
      },
      () => setLoading(false)
    );
  };

  const fetchLedger = () => {
    postAPI(
      STOCK_LEDGER,
      { item_id: id },
      (res) => {
        if (res.status) setLedger(res.data);
      },
      () => {}
    );
  };

  const ledgerColumns = [
    {
      title: "Date",
      dataIndex: "created_at",
      render: (d) => dayjs(d).format("DD MMM YYYY"),
    },
    {
      title: "Type",
      dataIndex: "type",
      render: (type) => {
        const colors = {
          in: "green",
          out: "blue",
          damage: "red",
          missing: "volcano",
          opening: "purple",
        };
        return <Tag color={colors[type]}>{type.toUpperCase()}</Tag>;
      },
    },
    { title: "Qty", dataIndex: "qty" },
    { title: "Remark", dataIndex: "remark" },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Item Details"
          extra={
            <Button onClick={() => navigate(-1)} type="primary" ghost>
              <RollbackOutlined />
            </Button>
          }
        >
          <Spin spinning={loading}>
            {item && (
              <Tabs defaultActiveKey="1">
                {/* 🔹 TAB 1: STOCK */}
                <Tabs.TabPane tab="Stock Summary" key="1">
                  <Descriptions bordered column={2}>
                    <Descriptions.Item label="Item Code">
                      {item.item_code}
                    </Descriptions.Item>
                    <Descriptions.Item label="Item Name">
                      {item.name}
                    </Descriptions.Item>
                    <Descriptions.Item label="Unit Rate">
                      ₹ {item.unit_rate}
                    </Descriptions.Item>
                    <Descriptions.Item label="Opening Qty">
                      {item.stock?.opening_qty ?? 0}
                    </Descriptions.Item>
                    <Descriptions.Item label="Current Qty">
                      <Tag
                        color={
                          item.stock?.current_qty <= 10 ? "red" : "green"
                        }
                      >
                        {item.stock?.current_qty ?? 0}
                      </Tag>
                    </Descriptions.Item>
                  </Descriptions>
                </Tabs.TabPane>

                {/* 🔹 TAB 2: LEDGER */}
                <Tabs.TabPane tab="Stock Ledger" key="2">
                  <Table
                    columns={ledgerColumns}
                    dataSource={ledger}
                    rowKey={(row) => row.id}
                    pagination={{ pageSize: 10 }}
                  />
                </Tabs.TabPane>
              </Tabs>
            )}
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default ItemDetail;
